export const regions = [
    'Vancouver Island',
    'Southwest Coast',
    'Northwest Coast',
    'Yukon',
    'Cariboos',
    'Monashees',
    'Selkirks',
    'Purcells',
    'North Rockies',
    'Central Rockies',
    'South Rockies',
    'East Coast',
]
